import { Component, AfterViewInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalConstantsService } from '../../services/global-constants.service';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'field-settings',
  templateUrl: './field-settings.component.html'
})
export class FieldSettingsComponent implements AfterViewInit {
  @Input() field;
  @Output() fieldChange = new EventEmitter<any>();
  @ViewChild('content') content: ElementRef;
  tempField = {}; // Placeholder for data being edited in the modal

  constructor(
    private modalService: NgbModal,
    private globalConstantsService: GlobalConstantsService,
    private toasterService: ToasterService
  ) { }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.field.label) {
        this.open(this.content);
      }
    }, 0);
  }

  open(content) {
    Object.assign(this.tempField, this.field);
    this.modalService.open(content).result.then(updatedField => {
      if (updatedField.scope === 'global') {
        updatedField.ord = 0;
        this.globalConstantsService.save(updatedField).subscribe(savedField => {
          this.toasterService.pop('success', 'Success', 'Field saved');
          Object.assign(this.field, savedField);
        });
      } else {
        Object.assign(this.field, updatedField);
      }

      this.fieldChange.emit(this.field);
    }).catch(reason => {
      // remove from fields array if cancel click
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/field-settings/field-settings.component.ts